module.exports = __webpack_public_path__ + "img/Cleopatra Esports.jpg";